// src/services/api/offlineSales/creditNotes.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/creditNote.routes.js
import { apiClient } from '../base';

export const getCreditNotes = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/credit-notes', { params });
  return response.data;
};

export const getCreditNote = async (creditNoteId) => {
  const response = await apiClient.get(`/offline-sales/credit-notes/${creditNoteId}`);
  return response.data;
};

export const issueCreditNote = async (data) => {
  const response = await apiClient.post('/offline-sales/credit-notes', data);
  return response.data;
};

export const applyCreditNote = async (creditNoteId, data) => {
  const response = await apiClient.post(`/offline-sales/credit-notes/${creditNoteId}/apply`, data);
  return response.data;
};

export const cancelCreditNote = async (creditNoteId) => {
  const response = await apiClient.post(`/offline-sales/credit-notes/${creditNoteId}/cancel`);
  return response.data;
};
